module.exports = __webpack_public_path__ + "static/img/demo-map.ed84bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-demo/images/demo-map.png
// module id = LEZL
// module chunks = 12